import { QueryClient } from "@tanstack/react-query";
import QueryKeys from "../api/queryKeys";
import { AVAttendantAssignment } from "../types/scheduling/avAttendant";
import { ISODateString } from "../types/date";
import { userCanUpdate } from "../components/scheduling/av_attendant/common";

export function updateAVACaches(queryClient: QueryClient, langGroupId: number, newAVAs: AVAttendantAssignment[]) {
  if (newAVAs.length === 0) return;
  queryClient.setQueriesData<AVAttendantAssignment[]>(
    { queryKey: [QueryKeys.AVAttendantAssignment, langGroupId] },
    (old) => {
      if (!old) return newAVAs;
      //combine new and old
      const newAvaIds = new Set<number>(newAVAs.map((ava) => ava.id));
      const updatedCache: AVAttendantAssignment[] = newAVAs;
      old.forEach((ava) => {
        if (!newAvaIds.has(ava.id)) {
          //add old in, if there isn't a new one with the same ID
          updatedCache.push(ava);
        }
      });
      return updatedCache;
    },
  );
}

export function deleteFromAVACaches(queryClient: QueryClient, langGroupId: number, assignmentId: number) {
  if (!assignmentId) return;
  queryClient.setQueriesData<AVAttendantAssignment[]>(
    { queryKey: [QueryKeys.AVAttendantAssignment, langGroupId] },
    (old) => (old ? old.filter((ava) => ava.id !== assignmentId) : []),
  );
}

export function deleteFromAVACachesByDate(queryClient: QueryClient, langGroupId: number, dates: ISODateString[]) {
  if (dates.length === 0) return;
  const dateSet = new Set(dates);

  queryClient.setQueriesData<AVAttendantAssignment[]>(
    { queryKey: [QueryKeys.AVAttendantAssignment, langGroupId] },
    (old) =>
      old
        ? old.filter((ava) => {
            // Keep assignments for dates not in the deletion set
            if (!dateSet.has(ava.date)) return true;

            // keep assignments that the user isn't allowed to delete
            if (!userCanUpdate(ava.type)) return true;

            // Delete it
            return false;
          })
        : [],
  );
}
